
import ArrowCircleLeft from "../../../assets/filled/ArrowCircleLeft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowCircleLeftIcon({ className, dataTestid = "ArrowCircleLeftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowCircleLeft data-testid={dataTestid} className={classes} {...rest} />
  );
}
